import { render, staticRenderFns } from "./MarkerMiniCard.vue?vue&type=template&id=3a977a28"
import script from "./MarkerMiniCard.vue?vue&type=script&lang=js"
export * from "./MarkerMiniCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../themes/custom/ef2_custom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports